import API from "@constants/API";
import { IPayloadHRIS } from "@typed/HRIS/allHris";

const BASE_URL = "https://api.dev.daily.co.id/hris/position/dashboard/v1/position";

export const getPositionsAPI = async () => {
  const response = await API.HTTP.get(`${BASE_URL}s`);
  return response.data;
};

export const getDetailPositionAPI = async (id: string) => {
  const response = await API.HTTP.get(`${BASE_URL}/${id}`);

  return response.data;
};

export const postPositionAPI = async (Data: object) => {
  const response = await API.HTTP.post(`${BASE_URL}`, Data);

  return response.data;
};

export const putPositionAPI = async ({ id, Data }: IPayloadHRIS) => {
  const response = await API.HTTP.put(`${BASE_URL}/${id}`, Data);

  return response.data;
};

export const putActivePositionAPI = async (id: string, isActive: boolean) => {
  const Data = {
    isActived: isActive ? false : true
  };
  const respose = await API.HTTP.put(`${BASE_URL}/${id}`, Data);
  return respose.data;
};

export const putDeletedPositionAPI = async (id: string, isDelete: boolean) => {
  const Data = {
    isDeleted: isDelete === false && true
  };
  const response = await API.HTTP.put(`${BASE_URL}/${id}`, Data);
  return response.data;
};
